import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

import LoginPage from "./components/LoginPage";
import PasswordlessLoginPage from "./components/PasswordlessLoginPage";
import VerificationPage from "./components/VerificationPage";
import PremiumServicePage from "./components/PremiumServicePage";
import WelcomePage from "./components/WelcomePage";
import UpsellServicePage from "./components/UpsellServicePage";
import UpgradeSuccessPage from "./components/UpgradeSuccessPage";
import CancelConfirmationPage from "./components/CancelConfirmationPage";
import ManageSubscriptionPage from "./components/ManageSubscriptionPage";
import SupportPage from "./components/SupportPage";
import InfoPage from "./components/InfoPage";
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedServiceRoute from "./components/ProtectedServiceRoute";
import ProtectedAdvancedServiceRoute from "./components/ProtectedAdvancedServiceRoute";

const App = () => {
  return (
    <Router>
      <Analytics />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/passwordless-login" element={<PasswordlessLoginPage />} />
        <Route path="/verify" element={<VerificationPage />} />
        <Route path="/welcome" element={<ProtectedRoute><WelcomePage /></ProtectedRoute>} />
        <Route path="/service" element={<ProtectedServiceRoute />} />
        <Route path="/search" element={<ProtectedAdvancedServiceRoute />} />
        <Route path="/premium" element={
          <ProtectedRoute requirePremium={true}>
            <PremiumServicePage />
          </ProtectedRoute>
        }
        />
        <Route path="/upgrade" element={
          <ProtectedRoute>
            <UpsellServicePage />
          </ProtectedRoute>
        }
        />
        <Route path="/upgrade/success" element={
          <ProtectedRoute>
            <UpgradeSuccessPage />
          </ProtectedRoute>
        }
        />
        <Route path="/cancel-confirmation" element={
          <ProtectedRoute requirePremium={true}>
            <CancelConfirmationPage />
          </ProtectedRoute>
        }
        />
        <Route path="/manage/membership" element={
          <ProtectedRoute requirePremium={true}>
            <ManageSubscriptionPage />
          </ProtectedRoute>
        }
        />
        <Route path="/support" element={
          <ProtectedRoute>
            <SupportPage />
          </ProtectedRoute>
        }
        />
        <Route path="/info" element={
          <ProtectedRoute>
            <InfoPage />
          </ProtectedRoute>
        }
        />
      </Routes>
    </Router >
  );
};

export default App;
